import { all, call, put, takeEvery } from "redux-saga/effects";
import API from "../../../Utils/api";
import {
  reportsSuccess,
  reportsFailure,
} from "../../Action";
import { REPORTS } from "../../Action/actionTypes";
import { notifyError } from "../../../Utils/Helper";

function* reportsRequest(action) {
  try {
    const { data } = yield API.post("/transaction-report", action?.payload?.payload);

    if (data?.meta?.code === 200) {
      yield put(reportsSuccess(data?.data));
      if (action?.payload?.callback) {
        yield call(action.payload.callback, data);
      }
    } else {
      yield put(reportsFailure());
      notifyError("Invalid Request.");
    }
  } catch (error) {
    yield put(reportsFailure());
    notifyError("Invalid Request.");
  }
}

export function* watchReportsAPI() {
  yield takeEvery(REPORTS, reportsRequest);
}

export default function* rootSaga() {
  yield all([watchReportsAPI()]);
}
